import React from "react";

import List from "../common/List/List";
import TitleCell from "../common/List/TitleCell";

import uniqid from "uniqid";
import HistoryRow from "./HistoryRow";

export default function HistoryList({ histories }) {
  const titles = [
    "時間",
    "人員",
    "操作項目",
    "API路徑",
    "操作前物件",
    "操作後物件",
  ];

  return (
    <div>
      <List gridCols="grid-cols-[repeat(3,min-content)_repeat(3,1fr)]">
        {titles.map((text) => (
          <TitleCell key={uniqid()} text={text} />
        ))}
        {histories.map((history) => (
          <HistoryRow key={uniqid()} history={history} />
        ))}
      </List>
    </div>
  );
}
